var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['overlay', _vm.overlayClass]},[_c('div',{staticClass:"modal"},[(_vm.isActive)?_c(_vm.componentName,_vm._b({tag:"component"},'component',_vm.data,false)):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }